import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import {
  RouteAction,
  RestaurantAction
} from 'actions';

import { Restaurant } from 'PMT/entities';
import { RestaurantsGroup } from 'PMT/entities/restaurantsGroup';

export default class ChooseRestaurantView extends Component {

  static defaultProps = {
    level: 0
  };

  static propTypes = {
    restaurantsGroup: PropTypes.objectOf(RestaurantsGroup).isRequired,

    onClick: PropTypes.func.isRequired,

    onPrevious: PropTypes.func.isRequired
  };

  //
  // Renderers
  //

  renderRestaurantsList() {
    return this.props.restaurantsGroup.restaurantsIds.map((restaurantId) => {

      // TODO: it's a workaround because we don't have the restaurant name
      const restaurant: Restaurant = new Restaurant();
      restaurant.id = restaurantId;

      return (
        <div
          className="restaurant_row"
          onClick={() => { this.props.onClick(restaurant); }}
        >
          {restaurantId}
          {/* {restaurant.name} */}
        </div>
      );
    });
  }

  render() {
    return (
      <div
        className="choose_restaurant_view"
      >
        <h3 className="text-center">
          {this.props.restaurantsGroup.name}
        </h3>

        <a
          onClick={this.props.onPrevious}
        >
          Précédent
        </a>

        {this.renderRestaurantsList()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/header/components/ChooseRestaurantView.js